import { getDemoAdForRoute } from '../ads/demoPlacements'

export const MarketAdBanner = () => {
  const ad = getDemoAdForRoute()
  const isImage = ad.variant === 'image' && ad.imageUrl
  const isPlaceholder = ad.variant === 'placeholder'

  return (
    <aside
      className={`market-ad-banner${
        isImage ? ' market-ad-banner--image' : ''
      }${isPlaceholder ? ' market-ad-banner--placeholder' : ''}`}
      role="complementary"
      aria-label="Реклама"
    >
      <span className="market-ad-banner__badge">Реклама</span>
      {isPlaceholder ? (
        <p className="market-ad-banner__placeholder-text">
          {ad.title}{' '}
          <a href={ad.href}>{ad.subtitle}</a>
        </p>
      ) : isImage ? (
        <a
          className="market-ad-banner__link market-ad-banner__link--image"
          href={ad.href}
          target="_blank"
          rel="noopener noreferrer sponsored"
          aria-label={`${ad.title}. ${ad.subtitle}`}
        >
          <img
            className="market-ad-banner__image"
            src={ad.imageUrl}
            srcSet={
              ad.imageUrl2x ? `${ad.imageUrl} 1x, ${ad.imageUrl2x} 2x` : undefined
            }
            width={ad.imageWidth}
            height={ad.imageHeight}
            alt={ad.imageAlt ?? ad.title}
          />
        </a>
      ) : (
        <a
          className="market-ad-banner__link"
          href={ad.href}
          target="_blank"
          rel="noopener noreferrer sponsored"
        >
          <div className="market-ad-banner__text">
            <strong className="market-ad-banner__title">{ad.title}</strong>
            <span className="market-ad-banner__subtitle">{ad.subtitle}</span>
          </div>
          {ad.cta ? <span className="market-ad-banner__cta">{ad.cta}</span> : null}
        </a>
      )}
    </aside>
  )
}
